import { Breadcrumb } from 'antd';
import { LayoutCMS } from 'components';
import React from 'react';
import { Link } from 'react-router-dom';
import TableVideos from './libraries';

export const PageVideosComponent = (props: any) => {
    const title = 'Videos';
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    <Link to="/article/videos">{title}</Link>
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };
    return (
        <LayoutCMS {...layoutCMSProps}>
            <TableVideos />
        </LayoutCMS>
    );
};

export default PageVideosComponent;



// WEBPACK FOOTER //
// ./src/pages/videos/component.tsx